module.exports = __webpack_public_path__ + "static/media/payroll.272b6a6c.svg";